import { css } from '@emotion/react';
import { flex, margins } from '@spotnana/blocks/src/utils';

export const carousel_container = css`
  ${margins.yt.half}
  position: relative;
  overflow: hidden;
`;

export const cards_container = css`
  ${flex.init}
  ${margins.yb.m1}
  transition: margin-left 0.2s ease;
`;

export const carousel_header = css`
  ${flex.init}
  ${flex.justify.between}
  ${flex.align.center}
  ${margins.xl.half}
`;

export const carousel_footer = css`
  ${flex.init}
  ${flex.justify.between}
  ${flex.align.center}
  ${margins.xl.half}
`;

export const footer_arrow_wrapper = css`
  ${flex.init}
  ${flex.justify.between}
  width: 120px;
`;

export const footer_arrow_btn = css`
  ${flex.init}
  ${flex.align.center}
  ${flex.justify.center}
  width: 48px;
  height: 48px;
`;
